import { CButton, CImg } from '@coreui/react';
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { AppLabels } from '../core/AppLabels';
import logoImg from '../img/Karma.png';
import logoTinyImg from '../img/KarmaTiny.png';
import signOutImg from '../img/signout.png';

interface ISecurity {
	Logout(): Promise<boolean>;
	isAuth(): boolean;
}

interface IDisableHomeRedirection {
	DisableHomeRedirection: boolean;
}

interface IProps {
	securityService: ISecurity;
	userFullName: string;
	disableRedirection?: IDisableHomeRedirection;
}

interface IState {
	redirectUrl: string,
}

// Bandeau sup�rieur de l'�cran
export class NavMenu extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			redirectUrl: "",
		};
	}

	//#region React Hacks

	// Lors de l'utilisation de l'historique, le champ redirectUrl n'est pas vide, cela provoquait un bug d'affichage (absence de barre de nav)
	// Pour �viter cela, apr�s chaque redirect, on r�initialise la valeur
	componentDidUpdate = () => {
		if (this.state.redirectUrl != "") this.setState({ redirectUrl: "" });
	}

	//#endregion 

	//#region Local events

	// Clic sur bouton logout
	onLogoutClick = async () => {
		let result = await this.props.securityService.Logout();
		console.log("onLogoutClick");
		console.log(result);
		this.setState({ redirectUrl: "/" });
	}

	// Clic sur le logo Karma => Redirige sur page d'accueil
	onClick = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {

		if (this.props.disableRedirection) {
			if (this.props.disableRedirection.DisableHomeRedirection == true) {
				e.preventDefault();
				return false;
			}
		}

		if (document.location.pathname != "/") {

			this.setState({ redirectUrl: "/" });
		}
	}

	//#endregion Local events

	//#region Rendus

	// Rendu de bouton menu de d�connexion
	renderLogoutButton = () => {
		let name = this.props.userFullName; 
		if (name == "") name = AppLabels.unauthenticated;

		return (
			<CButton size="sm" color="danger" role="button" onClick={this.onLogoutClick}>
				<span>{name}</span>
				<CImg className='icon' src={signOutImg} />
				</CButton>
		)
	}

	// Rendu principal
	// Voir �galement la feuille de style (site.css, groupe .NavMenu) qui conditionne certains affichage selon la taille d'�cran
	render() {
		if (this.state.redirectUrl) return <Redirect to={this.state.redirectUrl} ></Redirect>
		let logoClass = "logo";
		let logoTinyClass = "logoTiny";
		if (this.props.disableRedirection) {
			let homeRedirectionIsDisabled = this.props.disableRedirection.DisableHomeRedirection
			if (homeRedirectionIsDisabled && homeRedirectionIsDisabled == true) {
				logoClass = logoClass + " grayed";
				logoTinyClass = logoTinyClass + " grayed";
			}
		}
		
		let logoutBtn = this.props.securityService.isAuth() ? this.renderLogoutButton() : ""
		return (
			<header className="NavMenu">
				<a className={logoClass} href="#"><CImg src={logoImg} onClick={this.onClick}></CImg></a>
				<a className={logoTinyClass} href="#"><CImg src={logoTinyImg} onClick={this.onClick}></CImg></a>
					{logoutBtn}
			</header>
		);
	}

	//#endregion 

}
